import React, { useEffect, useState } from "react";
import { formatDateDDMMYYYY } from "../../../utils/commonFunctions";
import url from "../../../services/url";
import BASE from "../../../config";
import { LOGOS } from "../../../utils/companyLogosObj";

function ConsentForm({ candidate, s3Files }) {
  const [signature, setSignature] = useState([]);
  const [businessType, setBusinessType] = useState("");
  const domParser = new DOMParser();
  const [html,setHtml] = useState()

  const content = {
    maxicus: {
      text: `<div id="data"><tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  As part of the onboarding process at Maxicus, we
                  require certain personal information from you to
                  facilitate your employment. This information includes, but
                  is not limited to, details such as your PAN card, Aadhar
                  card, education history, former employment details, and
                  references. Additionally, background verification may be
                  conducted, encompassing your physical address, criminal
                  history, and employment background.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Background verification may include checks on your
                  physical address, criminal history, and employment
                  background. Please be assured that such verification will
                  be conducted in compliance with applicable laws and
                  regulations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By proceeding with the onboarding process, you hereby
                  consent to the collection, processing, and retention of
                  these specific personal details by Maxicus for the
                  duration of your employment and as required by law. Your
                  information will be treated with the utmost
                  confidentiality and will only be used for legitimate
                  business purposes associated with your employment,
                  including payroll, benefits administration, and compliance
                  with legal obligations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Maxicus is committed to protecting your privacy and
                  ensuring the security of your personal information. We
                  will not disclose, share, or sell your information to any
                  unauthorized third parties.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By completing the onboarding process, you acknowledge that
                  you have read and understood the terms of this onboarding
                  consent disclaimer.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  If you have any questions or require further
                  clarification, please contact your HR department or
                  designated contact.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>Thank you for joining Maxicus.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr></div>`,
      label : 'Maxicus Technologies Pvt. Ltd.',
    },
    kochar: {
      label : 'KOCHAR INFOTECH LTD.',
      text : `<div id="data"><tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  As part of the onboarding process at KocharTech, we
                  require certain personal information from you to
                  facilitate your employment. This information includes, but
                  is not limited to, details such as your PAN card, Aadhar
                  card, education history, former employment details, and
                  references. Additionally, background verification may be
                  conducted, encompassing your physical address, criminal
                  history, and employment background.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Background verification may include checks on your
                  physical address, criminal history, and employment
                  background. Please be assured that such verification will
                  be conducted in compliance with applicable laws and
                  regulations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By proceeding with the onboarding process, you hereby
                  consent to the collection, processing, and retention of
                  these specific personal details by KocharTech for the
                  duration of your employment and as required by law. Your
                  information will be treated with the utmost
                  confidentiality and will only be used for legitimate
                  business purposes associated with your employment,
                  including payroll, benefits administration, and compliance
                  with legal obligations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  KocharTech is committed to protecting your privacy and
                  ensuring the security of your personal information. We
                  will not disclose, share, or sell your information to any
                  unauthorized third parties.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By completing the onboarding process, you acknowledge that
                  you have read and understood the terms of this onboarding
                  consent disclaimer.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  If you have any questions or require further
                  clarification, please contact your HR department or
                  designated contact.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>Thank you for joining KocharTech.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr></div>`
    },
    igzy: {
      label:"IGZY TECHNOLOGIES PVT. LTD.",
      text:`<div id="data"> <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  As part of the onboarding process at Igzy, we
                  require certain personal information from you to
                  facilitate your employment. This information includes, but
                  is not limited to, details such as your PAN card, Aadhar
                  card, education history, former employment details, and
                  references. Additionally, background verification may be
                  conducted, encompassing your physical address, criminal
                  history, and employment background.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Background verification may include checks on your
                  physical address, criminal history, and employment
                  background. Please be assured that such verification will
                  be conducted in compliance with applicable laws and
                  regulations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By proceeding with the onboarding process, you hereby
                  consent to the collection, processing, and retention of
                  these specific personal details by Igzy for the
                  duration of your employment and as required by law. Your
                  information will be treated with the utmost
                  confidentiality and will only be used for legitimate
                  business purposes associated with your employment,
                  including payroll, benefits administration, and compliance
                  with legal obligations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Igzy is committed to protecting your privacy and
                  ensuring the security of your personal information. We
                  will not disclose, share, or sell your information to any
                  unauthorized third parties.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By completing the onboarding process, you acknowledge that
                  you have read and understood the terms of this onboarding
                  consent disclaimer.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  If you have any questions or require further
                  clarification, please contact your HR department or
                  designated contact.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>Thank you for joining Igzy.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr></div>`,
    },
    kochiva: {
      label : "Kochiva Pvt. Ltd.",
      text : `<div id="data"><tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  As part of the onboarding process at Kochiva, we
                  require certain personal information from you to
                  facilitate your employment. This information includes, but
                  is not limited to, details such as your PAN card, Aadhar
                  card, education history, former employment details, and
                  references. Additionally, background verification may be
                  conducted, encompassing your physical address, criminal
                  history, and employment background.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Background verification may include checks on your
                  physical address, criminal history, and employment
                  background. Please be assured that such verification will
                  be conducted in compliance with applicable laws and
                  regulations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By proceeding with the onboarding process, you hereby
                  consent to the collection, processing, and retention of
                  these specific personal details by Kochiva for the
                  duration of your employment and as required by law. Your
                  information will be treated with the utmost
                  confidentiality and will only be used for legitimate
                  business purposes associated with your employment,
                  including payroll, benefits administration, and compliance
                  with legal obligations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Kochiva is committed to protecting your privacy and
                  ensuring the security of your personal information. We
                  will not disclose, share, or sell your information to any
                  unauthorized third parties.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By completing the onboarding process, you acknowledge that
                  you have read and understood the terms of this onboarding
                  consent disclaimer.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  If you have any questions or require further
                  clarification, please contact your HR department or
                  designated contact.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>Thank you for joining Kochiva.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr></div>`,
    },
    kocharsoft: {
      text: `<div id="data"><tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  As part of the onboarding process at Kochar Innovation, we
                  require certain personal information from you to
                  facilitate your employment. This information includes, but
                  is not limited to, details such as your PAN card, Aadhar
                  card, education history, former employment details, and
                  references. Additionally, background verification may be
                  conducted, encompassing your physical address, criminal
                  history, and employment background.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Background verification may include checks on your
                  physical address, criminal history, and employment
                  background. Please be assured that such verification will
                  be conducted in compliance with applicable laws and
                  regulations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By proceeding with the onboarding process, you hereby
                  consent to the collection, processing, and retention of
                  these specific personal details by Kochar Innovation for the
                  duration of your employment and as required by law. Your
                  information will be treated with the utmost
                  confidentiality and will only be used for legitimate
                  business purposes associated with your employment,
                  including payroll, benefits administration, and compliance
                  with legal obligations.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  Kochar Innovation is committed to protecting your privacy and
                  ensuring the security of your personal information. We
                  will not disclose, share, or sell your information to any
                  unauthorized third parties.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  By completing the onboarding process, you acknowledge that
                  you have read and understood the terms of this onboarding
                  consent disclaimer.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>
                  If you have any questions or require further
                  clarification, please contact your HR department or
                  designated contact.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table>
          <tbody>
            <tr>
              <td style="padding-top:20px">
                <p>Thank you for joining Kochar Innovation.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr></div>`,
      label : 'KOCHAR INNOVATION PVT LTD.',
    },
  }

  useEffect(() => {
    if (candidate?.candidateSignature?.length !== 0) {
      if (
        candidate?.documentType &&
        candidate?.documentType === "S3" &&
        BASE.storageType
      ) {
        setSignature(s3Files?.joining_sign);
      } else {
        setSignature(candidate?.candidateSignature);
      }
    }
    setBusinessType(candidate?.trf?.businessType.toLowerCase());
  }, [candidate, s3Files]);

  useEffect(() => {
    if(businessType){
      const htmlElement = domParser.parseFromString(content[businessType]?.text, "text/html")
      if(htmlElement){
        const allRows = htmlElement.getElementById("data").innerHTML;
        setHtml(allRows)
      }
    }
  },[businessType])

  return (
    <div id="container" class="formContainer">
      <table class="parent" width="100%">
        <tr>
          <td>
            <table width="100%" class="header">
              <tbody>
                <tr>
                  <td>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td style={{ paddingLeft: "1rem", width: "215px" }}>
                            <img width="170" id="logo" alt="logo" src={LOGOS[businessType]} />
                          </td>
                          <td>
                            <h1
                              style={{
                                textAlign: "center",
                                fontSize: "1.5rem",
                                fontWeight: 700,
                                padding: "2rem 0",
                                marginTop: 0
                              }}>
                                {content[businessType]?.label}
                            </h1>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>
                            <h1
                              style={{
                                textAlign: "center",
                                fontSize: "1.5rem",
                                fontWeight: 700,
                                padding: "1rem 0",
                                marginTop: 0
                              }}>
                              Onboarding Consent{" "}
                            </h1>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <br></br>
        <div dangerouslySetInnerHTML={{__html: html}}></div>
        {/* {domParser.parseFromString(content[businessType]?.text, "text/html")} */}
        <tr>
          <td style={{ paddingTop: "25px" }}>
            <table width="100%">
              <tbody>
                <tr>
                  <td style={{ paddingTop: "10px", width: "30%" }}>
                    <strong>Name</strong>
                  </td>
                  <td style={{ paddingTop: "10px", width: "70%" }}>
                    <strong>:</strong>{" "}
                    <span
                      style={{ borderBottom: "1px solid black" }}
                      id="name_1"
                      class="space">
                      {candidate?.name}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingTop: "10px", width: "30%" }}>
                    <strong>Date</strong>
                  </td>
                  <td style={{ paddingTop: "10px", width: "70%" }}>
                    <strong>:</strong>{" "}
                    <span
                      style={{ borderBottom: "1px solid black" }}
                      id="date_of_joining"
                      class="space">
                      {" "}
                      {candidate?.concentDate === null ||
                      !candidate?.concentDate
                        ? formatDateDDMMYYYY(new Date())
                        : formatDateDDMMYYYY(new Date(candidate?.concentDate))}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingTop: "10px", width: "30%" }}>
                    <strong> Signature</strong>
                  </td>
                  <td
                    style={{
                      paddingTop: "10px",
                      width: "70%",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem"
                    }}>
                    <strong>:</strong>
                    <div class="sig">
                      <img
                        id="signature"
                        src={
                          candidate?.documentType === "S3" && BASE.storageType
                            ? signature
                            : url() + signature[0]?.path
                        }
                        alt="signature"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </table>
    </div>
  );
}

export default ConsentForm;
